import { DollarApollo } from "vue-apollo/types/vue-apollo";
import { FetchResult } from "apollo-link";
import Mutation from "./mutation.gql";

export interface Result {
  resetAppUser: string;
}

export const resetAppUser = async <V>(
  apollo: DollarApollo<V>,
  appUserId: string
): Promise<FetchResult<Result>> => {
  const result = apollo.mutate({
    mutation: Mutation,
    variables: { appUserId }
  });
  await apollo.provider.defaultClient.cache.reset();
  return result;
};
